<template>
  <div class="yx-zzmm-page yx-statistics-common-page main-layout">
    <el-card class="box-outter">
      <div class="title-container" slot="header">
        <span class="title">按政治面貌报到统计</span>
      </div>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header">
          <div class="btn-group">
            <!-- 操作按钮 -->
            <div class="btn-left">
              <el-button type="primary" plain>导出</el-button>
            </div>
            <!-- 右侧操作按钮 -->
            <table-btns
              :tableColumns="tableColumns"
              @tableColumnsChange="tableColumnsChange"
              @refresh="pageGet(true)"
            ></table-btns>
          </div>
        </div>
        <div class="div-scroll">
          <c-table
            :data="pageData"
            :tableColumns="tableColumns"
            :pagination="pageParams"
            @change="pageGet"
            @selectionChange="selectionChange"
            @edit="goto"
            @delete="pageDel"
            v-loading="pageLoading"
          >
          </c-table>
        </div>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MExcel from "@/mixins/MExcel.js";
import Configs from "./data/zzmm";
import CSearch from "@/components/CSearch/index.vue";
import CTable from "@/components/CTable/index.vue";
import TableBtns from "@/components/TableBtns/index.vue";
let mPage = MPage({
  pagePath: "",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
export default {
  mixins: [mPage],
  name: "",
  components: { CSearch, CTable, TableBtns },
  data() {
    let { searchItems, tableColumns } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      idList: [],
      pageData: [
        {
          id: 1,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    goto(id) {
      if (id) {
        // this.$router.push("/lx/baseData/studentEdit/" + id);
      } else {
        // this.$router.push("/lx/baseData/studentAdd");
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    pageGetAfterFn(data) {
      data.records.forEach((item) => {
        item.sex = item.sex == 0 ? "男" : "女";
      });
      return data;
    },
    handleGetReviewer() {},
  },
};
</script>

